import { $Q } from "../utils/query-selector";
import api from "../services/api"
import { stringToHTML } from "../utils/to-html"
import Swiper, { Navigation, Thumbs, FreeMode, Pagination} from "swiper";
import { zoomImage } from "./zoom-image";

/**
  * Section rendering to return images of the selected variant
  * 
  * @returns {Object} - main image section
  * @returns {Object} - thumbs image section
  * 
  * @author Andres Briñez
  */

export function queryVariants(){
  const variantSelected = $Q('[name="id"]').value;
  const handleVariant = $Q('[name="id"]');

  sectionHandle(handleVariant.dataset.variant, variantSelected)
}

/**
 * Captures the HTML section of the product in question and returns the node of the images to replace
 * 
 * @param { data } handle Data element of the product to which the query will be made 
 * @param { String } variantid Id of the selected variant
 */

async function sectionHandle(handle, variantid){
  const dataHandle = `/products/${handle}`;
  const htmlResponse = await api.shopifyVariantByUrl(dataHandle,variantid);
  const queryPrincipal = await $Q(".main-product__slider", stringToHTML(htmlResponse));
  const variantPrice = await $Q(".main-product__detail--price", stringToHTML(htmlResponse));
  const variantAvailable = await $Q('[name="available"]', stringToHTML(htmlResponse));
  const variantColor = await $Q(".color_variable", stringToHTML(htmlResponse));
  const variantCuotes = await $Q(".mainproduct-closer__logo-element--logo-text", stringToHTML(htmlResponse));

  updateSection(
    queryPrincipal, 
    variantPrice, 
    variantAvailable.value, 
    variantColor, 
    '.main-product__slider', 
    '.main-product__detail--price', 
    '.main-product__detail--available', 
    '.color_variable'
  );
  updateCuotes(variantCuotes);
  updateSwiper();  
  zoomImage();
}

/** 
 * Inject new images node to the section and reloade the swiper
 * 
 * @param { object } newSection1 Object with the main images
 * @param { object } variantPrice Object with price modify
 * @param { object } variantAvailable Object that update the available of the product
 * @param { object } variantColor Object that update the color
 * @param { object } variantCuotes Object that update the price cuotes
 * 
 */

export function updateSection(
  variantImage, 
  variantPrice, 
  variantAvailable, 
  variantColor, 
  nodeImage, 
  nodePrice, 
  nodeAvailable, 
  nodeColor){
    
  const sectionPrincipal = $Q(nodeImage);
  const sectionPrice = $Q(nodePrice);
  const sectionAvailable = $Q(nodeAvailable);
  const secttionColor = $Q(nodeColor);
  
  if ( variantImage != null ) {
    sectionPrincipal.innerHTML = variantImage.innerHTML;
  }
  
  sectionPrice.innerHTML = variantPrice.innerHTML;
  secttionColor.innerHTML = variantColor.innerHTML;

  if ( variantAvailable == 'false' ) {
    const button = $Q('.add-sidecart')

    button.disabled = true

    sectionAvailable.classList.remove('hidden')
  }
  else {
    const button = $Q('.add-sidecart')

    button.disabled = false

    sectionAvailable.classList.add('hidden')
  }
  
}

function updateCuotes(variantCuotes){

  const sectionCuotes = $Q('.mainproduct-closer__logo-element--logo-text');

  sectionCuotes.innerHTML = variantCuotes.innerHTML;
}

function updateSwiper(){
  const swiper = new Swiper(".thumbs", {
    modules: [FreeMode],
    spaceBetween: 10,
    slidesPerView: 3,
    watchSlidesProgress: true,
    freeMode: true
  });

  new Swiper(".main-product__slider-principal", {
    modules: [Navigation, Thumbs, Pagination],
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    thumbs: {
      swiper: swiper,
    },
  });
}